<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Periodes
        </h2>
        <div class="actions">
            <button (click)="openModal({})" class="btn btn-primary">
                Toevoegen
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/periods'" [columnMapping]="[
            { key: 'name', label: 'Naam' },
            { key: 'start_date', label: 'Startdatum' },
            { key: 'end_date', label: 'Einddatum' },
          ]" [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
    </app-table-guru>
</div>